import { checkErrorExist, convertError } from './converters';
import { handleFirstResponse } from '../utils/util_api_response';
import toFormData from '../utils/ulti_object_helpers';
import { apiWrapper } from './helpers';
import { getGlobalState, STATE_KEYS } from '../configs/config_state';

import GLOBAL from '../configs/config_global';

// region OVERVIEW
export function getOverviewMenu(truckID, currentPage = 1, pageSize = 20) {
    return new Promise((resolve, reject) => {
        fetch(GLOBAL.FATHER_LINK + `/vendor/v2/foodtrucks/${truckID}/menu-overview?page=${currentPage}&per_page=${pageSize}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + GLOBAL.DATA.USER_TOKEN
            },
            timeout: 10000
        })
            .then((response) => handleFirstResponse(response))
            .then((response) => {
                if (!checkErrorExist(response)) {
                    console.log('[SUCCESS] GET MENU OVERVIEW', response);
                    resolve({
                        data: response.data || [],
                        currentPage: response['meta']['current_page'],
                        lastPage: response['meta']['last_page'],
                        totalResult: response['meta']['total']
                    });
                }
                else {
                    console.log('[FAILED] GET MENU OVERVIEW', response);
                    reject(convertError(response.errors));
                }
            })
            .catch((error) => {
                console.log('[FAILED] GET MENU OVERVIEW', error.message);
                reject(error.message);
            });
    });
}
// endregion

// CATEGORY

// region Get Category List
export function getCategoryList(truckID, currentPage = 1, pageSize = 20) {
    return new Promise((resolve, reject) => {
        fetch(GLOBAL.FATHER_LINK + `/vendor/v2/foodtrucks/${truckID}/menus?page=${currentPage}&per_page=${pageSize}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + GLOBAL.DATA.USER_TOKEN
            },
            timeout: 10000
        })
            .then((response) => response.json())
            .then((response) => {
                if (!checkErrorExist(response)) {
                    console.log('[SUCCESS] GET MENU CATEGORIES', response);
                    resolve({
                        data: response.data || [],
                        currentPage: response['meta']['current_page'],
                        lastPage: response['meta']['last_page'],
                        totalResult: response['meta']['total']
                    });
                }
                else {
                    console.log('[FAILED] GET MENU CATEGORIES', response);
                    reject(convertError(response.errors));
                }
            })
            .catch((error) => {
                console.log('[FAILED] GET MENU CATEGORIES', error.message);
                reject(error.message);
            });
    });
}
// endregion

// region Create New Category
export function createCategory(truckID, categoryName, order = 1, squareLocationID = null) {
    return new Promise((resolve, reject) => {
        fetch(GLOBAL.FATHER_LINK + `/vendor/v2/foodtrucks/${truckID}/menus`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + GLOBAL.DATA.USER_TOKEN
            },
            body: JSON.stringify(Object.assign({
                name: categoryName,
                order
            }, squareLocationID ? { squareup_location_id: squareLocationID } : {}))
        })
            .then((response) => response.json())
            .then((response) => {
                if (!response.hasOwnProperty('errors')) {
                    response['food_items_count'] = 0;
                    resolve(response);
                    console.log('[SUCCESS] CREATE NEW CATEGORY', response);
                }
                else {
                    reject(convertError(response.errors));
                    console.log('[FAILED] CREATE NEW CATEGORY', response);
                }
            })
            .catch((error) => {
                console.log('[FAILED] CREATE NEW CATEGORY', error.message);
                reject(error.message);
            });
    });
}
// endregion

// region Edit Category Name
export function editCategory(truckID, categoryID, newName) {
    return new Promise((resolve, reject) => {
        fetch(GLOBAL.FATHER_LINK + `/vendor/v2/foodtrucks/${truckID}/menus/${categoryID}`, {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + GLOBAL.DATA.USER_TOKEN
            },
            body: JSON.stringify({ name: newName }),
            timeout: 10000
        })
            .then((response) => response.status === 204 ? {} : response.json())
            .then((response) => {
                if (!response.hasOwnProperty('errors')) {
                    resolve(response);
                    console.log('[SUCCESS] EDIT CATEGORY', response);
                }
                else {
                    reject(convertError(response.errors));
                    console.log('[FAILED] EDIT CATEGORY', response);
                }
            })
            .catch((error) => {
                console.log('[FAILED] EDIT CATEGORY', error.message);
                reject(error.message);
            });
    });
}
// endregion

// region Update Category Order
export function updateCategoryOrder(truckID, sortArr = []) {
    return new Promise((resolve, reject) => {
        fetch(GLOBAL.FATHER_LINK + `/vendor/v2/foodtrucks/${truckID}/menus/sort`, {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + GLOBAL.DATA.USER_TOKEN
            },
            body: JSON.stringify({ categories: sortArr })
        })
            .then((response) => response.status === 204 ? {} : response.json())
            .then((response) => {
                if (!response.hasOwnProperty('errors')) {
                    resolve(response);
                    console.log('[SUCCESS] UPDATE CATEGORY ORDER', response);
                }
                else {
                    reject(convertError(response.errors));
                    console.log('[FAILED] UPDATE CATEGORY ORDER', response);
                }
            })
            .catch((error) => {
                console.log('[FAILED] UPDATE CATEGORY ORDER', error.message);
                reject(error.message);
            });
    });
}
// endregion

// region Delete Category
export function deleteCategory(truckID, categoryID) {
    return new Promise((resolve, reject) => {
        fetch(GLOBAL.FATHER_LINK + `/vendor/v2/foodtrucks/${truckID}/menus/${categoryID}`, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + GLOBAL.DATA.USER_TOKEN
            },
            timeout: 10000
        })
            .then((response) => response.status === 204 ? {} : response.json())
            .then((response) => {
                if (!response.hasOwnProperty('errors')) {
                    resolve(response);
                    console.log('[SUCCESS] DELETE CATEGORY', response);
                }
                else {
                    reject(convertError(response.errors));
                    console.log('[FAILED] DELETE CATEGORY', response);
                }
            })
            .catch((error) => {
                console.log('[FAILED] DELETE CATEGORY', error.message);
                reject(error.message);
            });
    });
}
// endregion

// FOOD ITEM

// region List Food Items in Category
export function getFoodItems(truckID, categoryID, currentPage = 1, pageSize = 20) {
    return new Promise((resolve, reject) => {
        let link = GLOBAL.FATHER_LINK + `/vendor/v2/foodtrucks/${truckID}/menus/${categoryID}/items?page=${currentPage}&per_page=${pageSize}`;
        fetch(link, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + GLOBAL.DATA.USER_TOKEN
            }
        })
            .then((response) => handleFirstResponse(response))
            .then((response) => {
                if (!checkErrorExist(response)) {
                    console.log('[SUCCESS] GET FOOD ITEMS', response);
                    resolve({
                        data: response.data || [],
                        currentPage: response['meta']['current_page'],
                        lastPage: response['meta']['last_page'],
                        totalResult: response['meta']['total']
                    });
                }
                else {
                    reject(convertError(response.errors));
                    console.log('[FAILED] GET FOOD ITEMS', response);
                }
            })
            .catch((error) => {
                console.log('[FAILED] GET FOOD ITEMS', error.message);
                reject(error.message);
            });
    });
}
// endregion

// region Create New Food Item
export function createFoodItem(truckID, categoryID, itemData) {
    let data = toFormData(itemData, { indices: true, nullsAsUndefineds: true, booleansAsIntegers: true });

    return new Promise((resolve, reject) => {
        console.log('[INFO] CREATE NEW FOOD ITEM (DATA)', data);
        fetch(GLOBAL.FATHER_LINK + `/vendor/v2/foodtrucks/${truckID}/menus/${categoryID}/items`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + GLOBAL.DATA.USER_TOKEN
            },
            body: data
        })
            .then((response) => response.json())
            .then((response) => {
                if (!response.hasOwnProperty('errors')) {
                    resolve(response);
                    console.log('[SUCCESS] CREATE NEW FOOD ITEM', response);
                }
                else {
                    reject(convertError(response.errors));
                    console.log('[FAILED] CREATE NEW FOOD ITEM', response);
                }
            })
            .catch((error) => {
                console.log('[FAILED] CREATE NEW FOOD ITEM', error);
                reject(error.message);
            });
    });
}
// endregion

// region Edit Food Item
export function editFoodItem(truckID, categoryID, itemData) {
    const data = toFormData(itemData, { indices: true, nullsAsUndefineds: true, booleansAsIntegers: true });
    data.append('_method', 'PATCH');

    return new Promise((resolve, reject) => {
        console.log('[INFO] UPDATE FOOD ITEM (DATA)', itemData);
        fetch(GLOBAL.FATHER_LINK + `/vendor/v2/foodtrucks/${truckID}/menus/${categoryID}/items/${itemData.id}`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + GLOBAL.DATA.USER_TOKEN
            },
            body: data
        })
            .then((response) => response.json())
            .then((response) => {
                if (!response.hasOwnProperty('errors')) {
                    resolve(response);
                    console.log('[SUCCESS] EDIT FOOD ITEM', response);
                }
                else {
                    reject(convertError(response.errors));
                    console.log('[FAILED] EDIT FOOD ITEM', response);
                }
            })
            .catch((error) => {
                console.log('[FAILED] EDIT FOOD ITEM', error.message);
                reject(error.message);
            });
    });
}
// endregion

// region Update Food List Order
export function updateFoodListOrder(truckID, categoryID, sortArr = []) {
    return new Promise((resolve, reject) => {
        fetch(GLOBAL.FATHER_LINK + `/vendor/v1/foodtrucks/${truckID}/menus/${categoryID}/sort`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + GLOBAL.DATA.USER_TOKEN
            },
            body: JSON.stringify({ food_item: sortArr }),
            timeout: 10000
        })
            .then((response) => response.status === 204 ? {} : response.json())
            .then((response) => {
                if (!response.hasOwnProperty('errors')) {
                    resolve(response);
                    console.log('[SUCCESS] UPDATE FOOD LIST ORDER', response);
                }
                else {
                    reject(convertError(response.errors));
                    console.log('[FAILED] UPDATE FOOD LIST ORDER', response);
                }
            })
            .catch((error) => {
                console.log('[FAILED] UPDATE FOOD LIST ORDER', error.message);
                reject(error.message);
            });
    });
}
// endregion

// region Delete Food Item
export function deleteItem(truckID, categoryID, itemID) {
    return new Promise((resolve, reject) => {
        fetch(GLOBAL.FATHER_LINK + `/vendor/v2/foodtrucks/${truckID}/menus/${categoryID}/items/${itemID}`, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + GLOBAL.DATA.USER_TOKEN
            },
            timeout: 10000
        })
            .then((response) => response.status === 204 ? {} : response.json())
            .then((response) => {
                if (!response.hasOwnProperty('errors')) {
                    resolve(response);
                    console.log('[SUCCESS] DELETE FOOD ITEM', response);
                }
                else {
                    reject(convertError(response.errors));
                    console.log('[FAILED] DELETE FOOD ITEM', response);
                }
            })
            .catch((error) => {
                console.log('[FAILED] DELETE FOOD ITEM', error.message);
                reject(error.message);
            });
    });
}
// endregion

// FOOD ITEM MODIFIER

// region Create New Modifier
export function createFoodModifier(truckID, categoryID, foodItemID, newModifierData) {
    return new Promise((resolve, reject) => {
        fetch(GLOBAL.FATHER_LINK + `/vendor/v2/foodtrucks/${truckID}/menus/${categoryID}/items/${foodItemID}/modifiers`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + GLOBAL.DATA.USER_TOKEN
            },
            body: JSON.stringify(newModifierData)
        })
            .then((response) => response.json())
            .then((response) => {
                if (!checkErrorExist(response)) {
                    console.log('[SUCCESS] CREATE NEW MODIFIER', response);
                    resolve(response);
                }
                else {
                    console.log('[FAILED] CREATE NEW MODIFIER', response);
                    reject(convertError(response.errors));
                }
            })
            .catch((error) => {
                console.log('[FAILED] CREATE NEW MODIFIER', error);
                reject(error.message);
            });
    });
}
// endregion

// region Edit Modifier
export function editFoodModifier(truckID, categoryID, foodItemID, modifierData) {
    return new Promise((resolve, reject) => {
        const link = GLOBAL.FATHER_LINK + `/vendor/v2/foodtrucks/${truckID}/menus/${categoryID}/items/${foodItemID}/modifiers/${modifierData.id}`;
        console.log('[INFO] editModifier data', modifierData);
        fetch(link, {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + GLOBAL.DATA.USER_TOKEN
            },
            body: JSON.stringify(Object.assign({ _method: 'PATCH' }, modifierData))
        })
            .then((response) => response.json())
            .then((response) => {
                if (!checkErrorExist(response)) {
                    resolve(response);
                    console.log('[SUCCESS] EDIT MODIFIER', response);
                }
                else {
                    reject(convertError(response.errors));
                    console.log('[FAILED] EDIT MODIFIER', response);
                }
            })
            .catch((error) => {
                console.log('[FAILED] EDIT MODIFIER', error.message);
                reject(error.message);
            });
    });
}
// endregion

// region Delete Modifier
export function deleteFoodModifier(truckID, categoryID, foodItemID, modifierID) {
    return new Promise((resolve, reject) => {
        fetch(GLOBAL.FATHER_LINK + `/vendor/v2/foodtrucks/${truckID}/menus/${categoryID}/items/${foodItemID}/modifiers/${modifierID}`, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + GLOBAL.DATA.USER_TOKEN
            }
        })
            .then((response) => response.status === 204 ? {} : response.json())
            .then((response) => {
                if (!checkErrorExist(response)) {
                    console.log('[SUCCESS] DELETE MODIFIER', response);
                    resolve(response);
                }
                else {
                    console.log('[FAILED] DELETE MODIFIER', response);
                    reject(convertError(response.errors));
                }
            })
            .catch((error) => {
                console.log('[FAILED] DELETE MODIFIER', error.message);
                reject(error.message);
            });
    });
}
// endregion

// region POST - Import Menu From Square
export function importMenuFromSquare() {
    // Success code is 204
    return apiWrapper(
        `/vendor/v2/foodtrucks/${getGlobalState(STATE_KEYS.TRUCK_DATA)?.id}/square-menu`,
        'POST',
        'IMPORT MENU FROM SQUARE'
    );
}
// endregion
